import { create } from "zustand";

interface UserStore {
	user: any;
	userRole: any[];
	setUser: (user: any) => void;
	setUserRole: (userRole: any[]) => void;
	setUserData: (user: any, userRole: any[]) => void;
	getCurrentUser: () => any;
	getUserRole: () => any[];
}

export const useUserStore = create<UserStore>((set, get) => ({
	user: null,
	userRole: [],
	setUser: (user) => set({ user }),
	setUserRole: (userRole) => set({ userRole }),
	setUserData: (user, userRole) => set({ user, userRole }),
	getCurrentUser: () => get().user,
	getUserRole: () => get().userRole,
}));

// Export non-hook accessor for use in class methods
export const getUserStore = () => useUserStore.getState();
